import { render, staticRenderFns } from "./RecordingTableStore.vue?vue&type=template&id=22a010fb&scoped=true&"
import script from "./RecordingTableStore.vue?vue&type=script&lang=js&"
export * from "./RecordingTableStore.vue?vue&type=script&lang=js&"
import style0 from "./RecordingTableStore.vue?vue&type=style&index=0&id=22a010fb&scoped=true&lang=scss&ref=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a010fb",
  null
  
)

export default component.exports